
import { h, Component } from 'preact';
import style from './style.less'

export default (props)=>{
    let bodyStyle = [style.body]
    if(props.selected){
        bodyStyle.push(style.selected)
    }
    return (
        <div class={`${style.toggle} ${props.class || ''}`}>
            <div class={style.text}>
                {props.children}
            </div>
            <div class={bodyStyle.join(' ')} onClick={props.onSelect}>
                <div class={style.slider}></div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./components/elements/Toggle/index.js